import { render, staticRenderFns } from "./PageAnalyticsData.vue?vue&type=template&id=1fd037b0&"
import script from "./PageAnalyticsData.vue?vue&type=script&lang=js&"
export * from "./PageAnalyticsData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports